module.exports = __webpack_public_path__ + "static/feather-1-33a151a108216a92f85081c5b9e79cfa.png";